var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',[_c('v-flex',[_c('div',{staticClass:"appUnderwriterText"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.underwriterVerbiage)}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }